export default __webpack_public_path__ + "static/media/userManagement.477b8fd7.svg";